import { useEffect } from "react";
import { getDomainName, getStoreInfo } from "../../../utils/utils";
import {
  BannerService,
  MenuService,
  RestaurantService,
  TableService,
} from "../../../utils/api.services";
import { useDispatch, useSelector } from "react-redux";
import {
  setBanners,
  setLoaderStatus,
  setMenuCategories,
  setMenuItems,
  setRestaurantInfo,
  setTables,
} from "../../../store/reducers/datasReducer";
import { hideSpinner, showSpinner } from "../../../store/reducers/spinnerSlice";

export const useLanding = ({ callAPI }) => {
  const domainName = getDomainName();
  const dispatch = useDispatch();
  const { banners, menuItems, tables, menuCategories } =
    useSelector((state) => state.data);


  useEffect(() => {
    if (callAPI) {
      fetchRestaurantDetails();
    }
  }, []);

  const fetchRestaurantDetails = async () => {
    try {
      dispatch(showSpinner());
      const response = await RestaurantService.getRestaurantByDomainName(
        domainName
      );
      if (response?.data?.isActive == false) {
        localStorage.setItem("storeInfo", "INACTIVE");
      } else {
        localStorage.setItem("storeInfo", JSON.stringify(response?.data));
        dispatch(setRestaurantInfo(response?.data));
      }
      document.title = response?.data?.name || "Aduppankarai";
      fetchThemeColors();
      const restId = response?.data?._id;
      if (restId) {
        fetchAllBanners(restId);
        fetchAllMenus(restId);
        fetchAllTables(restId);
      }
    } catch (error) {
      console.error("Error fetching restaurant details:", error);
      // Restaurant was deleted or does not exist
      localStorage.setItem("storeInfo", "NOT_FOUND");
      dispatch(setRestaurantInfo(null));
      document.title = "Restaurant Not Found - Aduppankarai";
    } finally {
      setTimeout(() => {
        dispatch(hideSpinner());
      }, 500);
    }
  };
  const fetchAllBanners = async (restaurantId) => {
    const targetId = restaurantId || getStoreInfo()?._id;
    if (!targetId) return;
    try {
      dispatch(setLoaderStatus(true));
      const response = await BannerService.getAllBannersByRestaurantId(targetId);
      dispatch(setBanners(response?.data?.banners || []));
    } catch (error) {
      console.error("Error fetching banners:", error);
      dispatch(setBanners([]));
    } finally {
      dispatch(setLoaderStatus(false));
    }
  };
  const fetchAllMenus = async (restaurantId) => {
    const targetId = restaurantId || getStoreInfo()?._id;
    if (!targetId) return;
    try {
      dispatch(setLoaderStatus(true));
      const response = await MenuService.getAllMenuItems(targetId);
      const rawItems = response?.data?.menuItems || [];
      const catMap = new Map();
      rawItems.forEach((item) => {
        if (!item.category || item.availability === false || item.isActive === false) return;
        const trimmed = item.category.trim();
        const key = trimmed.toLowerCase();
        if (!catMap.has(key)) {
          catMap.set(key, trimmed);
        }
      });
      const uniqueCategories = ["All", ...Array.from(catMap.values())];
      dispatch(setMenuItems(rawItems));
      dispatch(setMenuCategories(uniqueCategories || []));
    } catch (error) {
      console.error("Error fetching menu items:", error);
    } finally {
      dispatch(setLoaderStatus(false));
    }
  };
  const fetchAllTables = async (restaurantId) => {
    const targetId = restaurantId || getStoreInfo()?._id;
    if (!targetId) return;
    try {
      dispatch(setLoaderStatus(true));
      const response = await TableService.getAllTablesByRestaurantId(targetId);
      dispatch(setTables(response?.data?.tables || []));
    } catch (error) {
      console.error("Error fetching menu items:", error);
    } finally {
      dispatch(setLoaderStatus(false));
    }
  };
  const fetchThemeColors = async () => {
    try {
      const theme = getStoreInfo();

      console.log(theme.primaryColor);

      if (theme) {
        document.documentElement.style.setProperty(
          "--primary",
          theme.primaryColor
        );
        document.documentElement.style.setProperty(
          "--primary-text",
          theme.primaryTextColor
        );
        document.documentElement.style.setProperty(
          "--secondary",
          theme.secondaryColor
        );
        document.documentElement.style.setProperty(
          "--secondary-text",
          theme.secondaryTextColor
        );
      }
    } catch (error) {
      console.error("Error fetching theme colors:", error);
    }
  };

  return { banners, menuItems, tables, menuCategories };
};
